<template>
    <!-- 条件筛选框 -->
    <div :class="[`${pageClass}-search`]">
        <div :class="[`${pageClass}-search-top`]">
            <div :class="[`${pageClass}-search-top-item`]">
                <span class="line"></span>
                <label class="text">学科</label>
                <el-select v-model="subjectId" class="select_center" placeholder="请选择学科" @change="selectSubject">
                    <el-option
                        v-for="(item, index) in subject"
                        :key="index"
                        :label="item"
                        :value="index">
                    </el-option>
                </el-select>
            </div>
            <div :class="[`${pageClass}-search-top-item`]">
                <span class="line"></span>
                <label class="text">测评模式</label>
                <el-select class="select_left" v-model="typeId" placeholder="请选择测评模式" @change="selectType">
                    <el-option
                        v-for="(item, index) in evaluationType"
                        v-show="!(!['9','10','11','12',''].includes(subjectId) && item.value === 100)"
                        :key="index"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
           
            <!-- <div v-if="navigationArr.length" :class="[`${pageClass}-search-top-item`]">
                <span class="line"></span>
                <label class="text">知识点/专题</label>
                <el-select v-model="navigationId" class="select_right" placeholder="请选择学科" @change="selectNavigation">
                    <el-option
                        v-for="(item, index) in navigationArr"
                        :key="index"
                        :label="item.title"
                        :value="item.id">
                    </el-option>
                </el-select>
            </div> -->
        </div>
        <!-- <div :class="[`${pageClass}-search-bottom`]">
            <el-select
                v-model="pname"
                filterable
                remote
                reserve-keyword
                placeholder="请输入要搜索的关键词"
                :remote-method="remoteMethod"
                >
                <el-option
                    v-for="(item, index) in dataList"
                    :key="index"
                    :label="item.title"
                    :value="item.title">
                </el-option>
            </el-select>
            <img @click="searchEvaluation" src="../../../assets/images/my-center/search.png" alt="">
            <div class="search-r" @click="searchEvaluation">搜索</div>
        </div> -->
    </div>
    
</template>
<script>
import { resource } from '../../../mixins/my_personal';
import evaluationType from 'ASSETS/js/evaluation-type.js'
export default {
    mixins: [resource],
    props: {
        dataList: {
            type: Array,
            default: function() {
                return []
            }
        },
        navigationArr: {
            type: Array,
            default: function() {
                return []
            }
        }
    },
    data() {
        return {
            evaluationType,
            pageClass: 'evaluationSearch',
            typeId: '',
            subjectId: '',
            pname: '',
            navigationId: '',
            typecode:''
        }
    },
    methods: {
        // 选择类型
        selectType(val) {
            this.navigationId = null
            this.$emit('selectType', val)
        },
        // 选择学科
        selectSubject(val) {
            console.log(this.subject,val,this.typeId)
            this.navigationId = null
            if(!['9','10','11','12'].includes(val) && this.typeId === 100){
                this.typeId = null
                this.selectType(null)
            }
            this.$emit('selectSubject', val)
        },
        // 输入关键字
        remoteMethod(val) {
            this.$emit('remoteMethod', val)
        },
        searchEvaluation() {
            this.$emit('searchEvaluationQuestion', this.pname)
        },
        selectNavigation(val) {
            this.$emit('selectNavigation', val)
        }
    }
}
</script>

<style lang="stylus" scoped>
.evaluationSearch {
    &-search {
      width: 850px;
      background-color: #ffffff;
      margin: 0 auto;
      padding-top: 20px;
      margin-bottom: 20px;
    //   box-shadow: 0 4px 3px -1px #c3c3c3;?
      &-top {
        height: 64px;
        border-bottom: 1px solid #c3c3c3;
        // display: flex;
        // justify-content: space-around;
        &-item {
          .line {
            width: 0px;
            height: 20px;
            border-left: 1px solid #585858;
            float: left;
            margin-top: 22px;
            margin-left: 40px;
          }

          .text {
            color: #585858;
            font-size: 18px;
            float: left;
            margin-left: 8px;
            line-height 64px;
          }
          /deep/ .el-select {
                height: 36px;
                margin-top: 13px;
                float: left;
                font-size: 164px;
                .el-input__inner {
                    color: #585858;
                    outline: none;
                    border: 1px solid #e2e2e2;
                    height: 36px;
                    font-size: 18px !important;
                }
            }
            >>> .select_left {
                width: 155px;
                margin-left: 18px;
            }
            >>> .select_center {
                width: 153px;
                margin-left: 18px;
            }
            >>> .select_right {
                width: 396px;
                margin-left: 18px;
            }
        }
      }

      &-bottom {
        height: 43px;
        padding: 0 38px;
        display: flex;
        justify-content: space-around; 
        border-radius: 22px;

        /deep/ .el-select {
            height: 43px;
            flex: 1;
            .el-select__tags {
                margin-top: 4px;
            }
            .el-select__input {
                font-size: 16px;
            }
            .el-input__inner {
                height: 43px;
                color: #585858;
                outline: none;
                font-size: 18px;
                border: 1px solid #e2e2e2;
                border-radious: 24px;
                line-height: 43px;
            }
        }

        .search-r {
          width: 98px;
          height: 43px;
          color: #fff;
          font-size: 18px;
          cursor: pointer;
          background-color: #7eb8ff;
          line-height: 43px;
          text-align: center;
        }
      }
    }
}
</style>